import { define } from "../preactement/define";
import { Accordion } from "../../Accordion";
import { jsx as _jsx } from "preact/compat/jsx-runtime";
const attributes = ['class-name', 'bordered'];

/* eslint-disable @typescript-eslint/no-namespace */

/* eslint-enable */

const Wrapper = _ref => {
  let {
    bordered,
    ...otherProps
  } = _ref;
  return /*#__PURE__*/_jsx(Accordion, {
    ...otherProps,
    bordered: bordered && Boolean(JSON.parse(bordered))
  });
};
define('ds-accordion', () => Wrapper, {
  attributes,
  shadow: true
});